import { MOMENT_TIME } from '../../momenttime'
import { FORMAT } from '../core/format'
import { PAIPAN } from '../core/paipan'
import * as consts from '../base/consts'

let CONTRAST_DATA_MANAGER = {
    /**
     * 根据服务器数据获取客户端对比列表数据
     * @param {服务器数据} listData 
     */
    getContrastListByList(listData) {
        let resultList = [];
        listData.forEach((data, index) => {
            let bzGanzhi = [];
            bzGanzhi[0] = FORMAT.getContrastEightWordArrByData(data.bzinfo[0].unknown, data.bzinfo[0].bz_sz);
            bzGanzhi[1] = FORMAT.getContrastEightWordArrByData(data.bzinfo[1].unknown, data.bzinfo[1].bz_sz);
            resultList.push(Object.assign(data, {
                cIndex: index,
                bzGZinfo: bzGanzhi,
            }))
        });
        console.log('getContrastListByList----', resultList)
        return resultList;
    },
    /**
     * 获取时间联动的list
     * @param {选中的年份} yearNum 
     * @param {需要参考的详细数据} ffData 
     */
    getContrastTimeInteractivedFortune(yearNum, ffData) {
        let begYear = ffData.fortuneListData[0].year;
        if(yearNum < begYear) {
            return null;
        }
        let dayunIndex = parseInt((yearNum-begYear)/10),
            liunianIndex = yearNum-(begYear+(dayunIndex*10));
        return {
            dayunIndex: dayunIndex, liunianIndex: liunianIndex
        }
    }
}

export {
    CONTRAST_DATA_MANAGER
}
